$shm_hitalama_map_widget_float_opencode_session $shm_hitalama_map_widget_float
	scrollable false
	content /
		<= Chat $shm_hitalama_agent_map_widget_session
			widget <= widget
			Map_page <= Map_page
